// extracted by mini-css-extract-plugin
export default {"price-container":"HvkLAY","priceContainer":"HvkLAY","tax-note":"fy1t_n","taxNote":"fy1t_n","full-price":"EJBq7m","fullPrice":"EJBq7m","light":"pGmPiC","hidden":"FXfrtl"};